import React, { memo } from 'react';
import { Chip } from '@material-ui/core';
import PropTypes from 'prop-types';
import WithModal from '../../../HOCs/WithModal';
import useStyles from './styles';

const AdditionalInfoModal = ({ children, buttonLabel }) => {
  const classes = useStyles();

  return (
    <WithModal
      WrappedComponent={({ label, className, onClick }) => (
        <Chip
          label={label}
          className={className}
          color="default"
          classes={classes}
          onClick={onClick}
        />
      )}
      label={buttonLabel}
      className={classes.root}
    >
      {children}
    </WithModal>
  );
};

AdditionalInfoModal.propTypes = {
  buttonLabel: PropTypes.string.isRequired,
  children: PropTypes.node.isRequired,
};

export default memo(AdditionalInfoModal);
